
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import park from "../../assets/images/park.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import Env from '../../runtimeEnv';

function TherapistTherapyRooms({
  // setCurrentNickname,
  // currentNickname,
  // handleLogout,
  // setFormType,
  // PlutonicuserID,
  // userType,
}) {
  const navigate = useNavigate();
  const [enabledRoom, setEnabledRoom] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const {
      currentNickname,
      setCurrentNickname,
      handleLogout,
      PlutonicuserID,
      userType,
      currentFormType,
      setCurrentFormType,
    } = useContext(AuthContext);

  useEffect(() => {
  const initializeState = async () => {
    // Get user ID and nickname from props or localStorage
    const savedUserID = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    const savedNickname = currentNickname || localStorage.getItem("currentNickname");

    if (savedNickname) {
      setCurrentNickname(savedNickname);
    }

    if (savedUserID) {
      try {
        // Fetch all meeting sessions for the user
        const response = await axios.get(
          `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
            params: { t: new Date().getTime() }, // Avoid caching with timestamp param
          }
        );
        console.log("🗂️ Full meetings response:", response.data);

        if (response.data.length > 0) {
          const nowUTC = new Date();

          // Define grace periods and suppression windows
          const gracePeriodBeforeMs = 15 * 60 * 1000; // 15 min before session
          const gracePeriodAfterMs = 75 * 60 * 1000;  // 60 min session + 15 min buffer
          const backToBackBufferMs = 20 * 60 * 1000;  // Suppress prior session if next starts within 20 min

          let latestUpcomingSession = null;

          // Group sessions by room ID
          const roomSessionsMap = response.data.reduce((acc, room) => {
            const roomId = room.meetingID.split("-")[0];
            const sessionTimeUTC = new Date(room.sessionTime);

            // Format session time for display in EST
            const formattedTimeEST = sessionTimeUTC.toLocaleString("en-US", {
              timeZone: "America/New_York",
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }) + " EST";

            if (!acc[roomId]) acc[roomId] = [];

            acc[roomId].push({
              meetingID: room.meetingID,
              sessionStartTimeEST: formattedTimeEST,
              sessionStartTimeUTC: sessionTimeUTC.toISOString(),
              rawStartTime: sessionTimeUTC,
              online: room.online.some((s) => s === true),
              selectedSpace: room.selectedSpace || "",
              isAvailable: false,
              isUpcoming: false,
            });

            console.log("🌴 Room Data:", room.meetingID, "→", room.selectedSpace);
            return acc;
          }, {});

          // Process each room's sessions to apply availability and primary selection logic
          Object.keys(roomSessionsMap).forEach((roomId) => {
            const sessions = roomSessionsMap[roomId];

            // Sort by start time (priority: isPrimary, then time)
            sessions.sort((a, b) => {
              if (a.isPrimary && !b.isPrimary) return -1;
              if (!a.isPrimary && b.isPrimary) return 1;
              return new Date(a.sessionStartTimeUTC) - new Date(b.sessionStartTimeUTC);
            });

            for (let i = 0; i < sessions.length; i++) {
              const current = sessions[i];
              const next = sessions[i + 1];

              const currentStart = new Date(current.sessionStartTimeUTC);
              const timeUntilCurrent = currentStart - nowUTC;
              const timeSinceCurrent = nowUTC - currentStart;

              const isInGraceWindow =
                (timeUntilCurrent <= gracePeriodBeforeMs && timeUntilCurrent >= 0) ||
                (timeSinceCurrent >= 0 && timeSinceCurrent <= gracePeriodAfterMs);

              const isUpcoming = timeUntilCurrent > 0 && timeUntilCurrent <= gracePeriodBeforeMs;

              let isSuppressed = false;

              // If there's a next session and it's within back-to-back buffer, suppress the current one
              if (next) {
                const nextStart = new Date(next.sessionStartTimeUTC);
                const timeUntilNext = nextStart - nowUTC;

                const allowSuppression =
                  timeUntilNext <= backToBackBufferMs &&
                  timeUntilNext >= -15 * 60 * 1000; // Allow slight overlap

                if (allowSuppression) {
                  isSuppressed = true;
                  next.isUpcoming = true; // Mark next session as upcoming
                }
              }

              current.isAvailable = isInGraceWindow;
              current.isUpcoming = isUpcoming;
              current.isPrimary = (isInGraceWindow || isUpcoming) && !isSuppressed;

              // Save the latest primary session that has a selectedSpace set
              if (
                current.isPrimary &&
                current.selectedSpace?.trim() !== "" &&
                (!latestUpcomingSession ||
                  currentStart > new Date(latestUpcomingSession.sessionStartTimeUTC))
              ) {
                latestUpcomingSession = current;
              }
            }
          });

          // Extract next available session time for each room
          const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce(
            (acc, [roomId, sessions]) => {
              const nextSession = sessions.find((s) => s.isAvailable || s.isUpcoming);
              if (nextSession) acc[roomId] = nextSession.sessionStartTimeEST;
              return acc;
            },
            {}
          );

          // Track whether each room has someone online
          const onlineStatusMap = Object.entries(roomSessionsMap).reduce(
            (acc, [roomId, sessions]) => {
              acc[roomId] = sessions.some((s) => s.online);
              return acc;
            },
            {}
          );

          // Set the space corresponding to the most relevant session
          if (latestUpcomingSession) {
            console.log("🧠 Latest session selectedSpace:", latestUpcomingSession.selectedSpace);
            setSelectedSpace(latestUpcomingSession.selectedSpace || null);
          } else {
            setSelectedSpace(null);
          }

          setRoomsOnlineStatus(onlineStatusMap);
          setEnabledRoom(roomSessionsMap);
          setSessionStartTimes(sessionStartTimesMap);
        }
      } catch (error) {
        console.error("Failed to fetch meeting details:", error);
      }
    }

    setLoading(false);
  };

  initializeState();
}, [PlutonicuserID]);


  const rooms = [
    {
      id: "beach",
      title: "Plutonic Therapy Beach Office",
      description:
        "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      available:
        enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
      isComingSoon: false,
      online: roomsOnlineStatus["beach"] || false,
      sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
      id: "mountain",
      title: "Plutonic Therapy Forest Office",
      description:
        "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: forest,
      available:
        enabledRoom["mountain"]?.some((session) => session.isAvailable) ||
        false,
      isComingSoon: false,
      online: roomsOnlineStatus["mountain"] || false,
      sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },

    {
      id: "park",
      title: "Plutonic Therapy Quiet Park",
      description:
        "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: park,
      available:
        enabledRoom["park"]?.some((session) => session.isAvailable) || false,
      isComingSoon: false,
      online: roomsOnlineStatus["park"] || false,
      sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
      id: "campsite",
      title: "Plutonic Therapy Campfire",
      description:
        "Unpack your thoughts with your licensed mental health professional next to the campfire. Nature holds space for you. The crickets hum, trees whisper, and stars listen.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available:
        enabledRoom["campsite"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
    },
  ];

  const handleEnterClick = (roomType, meetingID) => {
    // Handle test rooms
    if (roomType.startsWith("test-")) {
      const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const testMeetingID = `${roomType}-test-meeting-id`;
      sessionStorage.setItem("meetingID", testMeetingID);
      sessionStorage.setItem("userId", userId);

      const realRoomType = roomType.replace("test-", ""); // e.g., test-beach → beach
      navigate(`/unity-room/${realRoomType}`);
      return;
    }

    // Handle real rooms
    const roomSessions = enabledRoom[roomType];
    if (!roomSessions || roomSessions.length === 0) {
      alert("Room is not enabled. Please wait or check your eligibility.");
      return;
    }

    const session = roomSessions.find((s) => s.meetingID === meetingID);
    if (!session) {
      alert("Selected session is not available.");
      return;
    }

    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    sessionStorage.setItem("meetingID", session.meetingID);
    sessionStorage.setItem("userId", userId);
    navigate(`/unity-room/${roomType}`);
  };

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        
        // showButtons={true}
        
      />
      <div
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-12 self-start pl-4 mt-8">
          Your Virtual Spaces
        </h2>
        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              room={room}
              isSelected={selectedSpace === room.id}
              onEnterClick={(meetingID) => handleEnterClick(room.id, meetingID)}
              sessions={enabledRoom[room.id] || []}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TherapistTherapyRooms;


